import axiosInstance from '../../../axiosInstance';
import * as Type from '../../../constants';
import setAuthorizationToken from "../../../utils/setAuthorizationToken";
import {setStorage} from "../../../utils/helper";

export const changeRole = role => {
  return dispatch => dispatch({type: "CHANGE_ROLE", userRole: role})
}
export const login = async user => {
  return async dispatch => {
    try {
      let {data} = await axiosInstance.post('/auth/login', user);
      localStorage.setItem("token", data.token);
      // setAuthorizationToken(data.token);
      dispatch(setToken(data.token, null));
      dispatch({type: Type.LOGIN_ADMIN, user: data.userInfo});
      return {
        status: true
      }
    } catch (e) {
      console.log('err', e);
      return {
        status: false
      }
    }
  }
}

export function setToken(token, user) {
  return dispatch => {
    setStorage('token', token, parseInt(3 * 60 * 60));
    setAuthorizationToken(token);
    // dispatch(setCurrentUser(user));
  }
}

export function logout() {
  return dispatch => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiresIn');
    dispatch(setCurrentUser(null));
    delete axiosInstance.defaults.headers.common["Authorization"];
    // dispatch(setCurrentUser(null));
  }
}

export const getAllUsers = () => {
  return async dispatch => {
    try {
      let {data} = await axiosInstance.get('/users');
      dispatch({type: Type.GET_USERS, users: data.data})
    } catch (e) {
      console.log('err', e);
    }
  }
}

export function setCurrentUser(user) {
  return {
    type: "CLEAR_STORE",
    payload: {
      data: user
    }
  };
}
